/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Level_Ups_BodyInputs */



/**
* | output |
* | --- |
* | "Where the member was talking, a channel you pick, a DM, or nowhere." |
*
* @param {Features_Level_Ups_BodyInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const features_level_ups_body = /** @type {((inputs?: Features_Level_Ups_BodyInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Level_Ups_BodyInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Там, где участник общался, в выбранном вами канале, в личных сообщениях или нигде.")
	return /** @type {LocalizedString} */ ("Where the member was talking, a channel you pick, a DM, or nowhere.")
});